import { render, staticRenderFns } from "./TagListTag.vue?vue&type=template&id=0dc19025"
import script from "./TagListTag.vue?vue&type=script&lang=js"
export * from "./TagListTag.vue?vue&type=script&lang=js"
import style0 from "./TagListTag.vue?vue&type=style&index=0&id=0dc19025&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports